import React from "react"
import styled from "styled-components"
import media from "styled-media-query"
import Progress from "../organisms/progress"
import QHeader from "../molecules/q-header"
import Image from "../atoms/image"
import QText from "../atoms/q-text"
import ChoiceList from "../organisms/choice-list"
import MediaQuery from "react-responsive"

const Wrap = styled.div`
  ${media.greaterThan("small")`
    display: flex;
  `}
`
const SPWrap = styled.div`
  display: flex;
  margin: 5px 0;
  ${media.greaterThan("small")`
    display: block;
  `}
`
const PCLeftWrap = styled.div`
  ${media.greaterThan("small")`
    margin-right: 40px;
    width: 51%;
  `}
`
const PCRightWrap = styled.div`
  ${media.greaterThan("small")`
    flex:1;
    margin: 16px 0;
  `}
`
const StyledQText = styled(QText)`
  width: 60%;
  ${media.greaterThan("small")`
    width:100%;
  `}
`
const StyledGImage = styled.div`
  flex: 1;
  margin: 8px 0;
  ${media.greaterThan("small")`
    margin: -4px 0 0 8px;
    width: 100%;
  `}
`

const QuestionTemplate = props => {
  const index = props.index
  const resultList = props.resultList
  const gImageNameSP = props.gImageNameSP
  const gImageNamePC = props.gImageNamePC
  const qImageName = props.qImagename
  const data = props.data
  const select = props.select
  const choiceFunc = props.choiceFunc
  return (
    <>
      <Progress index={index} resultList={resultList} />
      <Wrap>
        <PCLeftWrap>
          <QHeader index={index} />
          <SPWrap>
            <StyledQText>{data.question}</StyledQText>
            <StyledGImage>
              <MediaQuery query="(max-width: 449px)">
                <Image name={gImageNameSP} />
              </MediaQuery>
              <MediaQuery query="(min-width: 450px)">
                <Image name={gImageNamePC} />
              </MediaQuery>
            </StyledGImage>
          </SPWrap>
        </PCLeftWrap>
        <PCRightWrap>
          <Image name={qImageName} />
          <ChoiceList
            elements={data.choices}
            func={choiceFunc}
            select={select}
          />
        </PCRightWrap>
      </Wrap>
    </>
  )
}

export default QuestionTemplate
